import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslateContext, useUserConfigContext } from "../Context";
import { HasRoleID } from 'fennec-ui';

var _ = require('lodash');

//-------------------------------------------------------------------
export function ycBucket(auth) {
    var bucketName = "federation"
    if (auth.appProfile != "prod") {
        bucketName = "federation-dev"
    }
    return bucketName;
}
//-------------------------------------------------------------------
// export const T = (props) => {
//     const { value, children } = props;
//     const translate = useSelector(REDUX_Translate.selector.object);
//     const [userConfig, setUserConfig] = useUserConfigContext();
//     let v = value || children;
//     return <>{t(v, translate, config)}</>
// };
export const t = (value, translate, config) => {
    let translateFunc = translate.bind({ translate, config });
    return translateFunc(value);
};
window.dict = {};
export function translate(value) {
    if (!_.isString(value)) return "";
    window.dict[value.toLowerCase().replaceAll(' ', '')] = value;

    if (this.config && this.translate && value) {
        let key = value.toLowerCase().replaceAll(' ', '');
        if (this.translate[key]) {
            let v = this.translate[key][(this.config.lang) ? this.config.lang : "ru"];
            if (!v || v === "") {
                return value;
            }
            return v
        }
    }
    return value;
}
//-----------------------------------------------------------------------------------
export const goTo = (href) => {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = href;
    a.target = "_blank"
    a.click();
    a.remove();
}
//-----------------------------------------------------------------------------------
export const isOrganizer = (user, eventID) => {
    // {ID: 1, name: 'Организатор'}
    return HasEventRoleID(user, eventID, 1)
}
export const isAdministrator = (user, eventID) => {
    // {ID: 2, name: 'Администратор'}
    return HasEventRoleID(user, eventID, 2)
}
export const isAnyAdministrator = (user, eventID) => {
    return isAdministrator(user, eventID) || isOrganizer(user, eventID) //|| isFederationAdministrator(user) || isFederationPresident(user)
}
export const isDancer = (user, eventID) => {
    // {ID: 3, name: 'Участник'}
    return HasEventRoleID(user, eventID, 3)
}
export const isMainJudge = (user, eventID) => {
    // {ID: 4, name: 'ГлавныйCудья'}
    return HasEventRoleID(user, eventID, 4)
}
export const isJudge = (user, eventID) => {
    // {ID: 5, name: 'Судья'}
    return HasEventRoleID(user, eventID, 5)
}
export const isAnyJudge = (user, eventID) => {
    return isJudge(user, eventID) || isMainJudge(user, eventID)
}
export const isPresenter = (user, eventID) => {
    // {ID: 6, name: 'Ведущий'}
    return HasEventRoleID(user, eventID, 6)
}
export const isDJ = (user, eventID) => {
    // {ID: 7, name: 'Диджей'}
    return HasEventRoleID(user, eventID, 7)
}
export const isViewerOnly = (user, eventID) => {
    // {ID: 8, name: 'Зритель'}
    return HasEventRoleID(user, eventID, 8)
}
export const isViewer = (user, eventID) => {
    // {ID: 8, name: 'Зритель'}
    return HasEventRoleID(user, eventID, 8) || isDancer(user, eventID)
}
export const isFederationAdministrator = (user) => {
    // {ID: 4, name: 'АдминистраторФедерации'}
    return hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 5 }, user.vseTipiPolzovatelei)
    // return HasRoleID(user, 4)
}
export const isFederationPresident = (user) => {
    // {ID: 3, name: 'ПрезидентФедерации'}
    return hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 9 }, user.vseTipiPolzovatelei)
    // return HasRoleID(user, 3)
}
export const isAnyFederationAdministrator = (user) => {
    return isFederationAdministrator(user) || isFederationPresident(user)
}

export const HasEventRole = (user, eventID, name) => {
    if (user && user.eventUserUser) {
        for (let i = 0; i < user.eventUserUser.length; i++) {
            const element = user.eventUserUser[i];
            if (element.eventUserType.name === name && element.meropriyatieID == eventID) {
                return true;
            }
        }
    }
    return false;
};
export const HasEventRoleID = (user, eventID, roleID) => {
    if (user && user.eventUserUser) {
        for (let i = 0; i < user.eventUserUser.length; i++) {
            const element = user.eventUserUser[i];
            if (element.eventUserTypeID === roleID && element.meropriyatieID == eventID) {
                return true;
            }
        }
    }
    return false;
};

export function hasActiveRight(params, vseTipiPolzovatelei) { //params - object type VseTipiPolzovatelei
    if (!params || !vseTipiPolzovatelei || !vseTipiPolzovatelei.length) {
        return false;
    }

    let objects = getRights(params, vseTipiPolzovatelei);
    if (!objects || !objects.length) {
        return false;
    }

    for (let i = 0; i < objects.length; i++) {
        let object = objects[i]
        if (object && object.dokumentZapisiID > 0 && object.dokumentPodtverzhdeniyaID > 0 && !object.dokumentOtmeniZapisiID) {
            return true;
        }
    }

    return false;
}

export function getRights(params, vseTipiPolzovatelei) { //params - object type VseTipiPolzovatelei
    if (!params || !vseTipiPolzovatelei || !vseTipiPolzovatelei.length) {
        return;
    }

    let result = [];

    for (let prop in params) {
        if (!(prop in vseTipiPolzovatelei[0])) {
            console.error('Не найдено свойство "' + prop + '" в объекте VseTipiPolzovatelei')
            return
        }
    }


    for (let i = 0; i < vseTipiPolzovatelei.length; i++) {
        const item = vseTipiPolzovatelei[i];

        if (params.userID > 0 && params.userID !== item.userID) {
            continue;
        }
        if (params.tipPolzovatelyaID > 0 && params.tipPolzovatelyaID !== item.tipPolzovatelyaID) {
            continue;
        }
        if (params.regionalnoeOtdelenieID > 0 && params.regionalnoeOtdelenieID !== item.regionalnoeOtdelenieID) {
            continue;
        }
        if (params.chlenFederatsiiID > 0 && params.chlenFederatsiiID !== item.chlenFederatsiiID) {
            continue;
        }
        if (params.tantsorID > 0 && params.tantsorID !== item.tantsorID) {
            continue
        }
        if (params.shkolaID > 0 && params.shkolaID !== item.shkolaID) {
            continue
        }
        if (params.paraID > 0 && params.paraID !== item.paraID) {
            continue
        }
        if (params.kollektivID > 0 && params.kollektivID !== item.kollektivID) {
            continue
        }
        if (params.prepodavatelID > 0 && params.prepodavatelID !== item.prepodavatelID) {
            continue
        }
        if (params.sudyaID > 0 && params.sudyaID !== item.sudyaID) {
            continue
        }
        if (params.organizatorID > 0 && params.organizatorID !== item.organizatorID) {
            continue
        }
        if (params.meropriyatieID > 0 && params.meropriyatieID !== item.meropriyatieID) {
            continue
        }

        result.push(item);
    }

    return result;
}
//-----------------------------------------------------------------------------------
// Интерфейсы:
//! isAnyFederationAdministrator - d
//! isAnyAdministrator - d/m
//  isDancer - m
//! isAnyJudge - m
//  isPresenter - m
//  isDJ - m
//  isViewer - m
//-----------------------------------------------------------------------------------
// var count = countByFuncs(dancers, [
//     (e)=> e.user.genderID === 1,
//     (e)=> e.user.genderID === 2,
// ]);
// console.log(count);
// [7, 10] 
export function countByFuncs(array, funcs) {
    if (!funcs || !_.isArray(funcs) || funcs.length == 0) return;
    let counts = funcs.map(e => 0);
    if (!array) return counts;
    if (!_.isArray(array)) return counts;
    if (array.length == 0) return counts;

    for (let i = 0; i < array.length; i++) {
        const element = array[i];
        for (let f = 0; f < funcs.length; f++) {
            const fun = funcs[f];
            if (fun(element)) counts[f] += 1;
        }
    }
    return counts;
}

// var count = countByObjFuncs(dancers, {
//     male: (e)=> e.user.genderID === 1,
//     female: (e)=> e.user.genderID === 2,
// })
// console.log(count);
// {male: 7, female: 10}
export function countByObjFuncs(array, objFuncs) {
    if (!objFuncs) return;
    let counts = {};
    for (const key in objFuncs) {
        if (Object.hasOwnProperty.call(objFuncs, key)) {
            counts[key] = 0;
        }
    }
    if (!array) return counts;
    if (!_.isArray(array)) return counts;
    if (array.length == 0) return counts;

    for (let i = 0; i < array.length; i++) {
        const element = array[i];
        for (const key in objFuncs) {
            if (Object.hasOwnProperty.call(objFuncs, key)) {
                const fun = objFuncs[key];
                if (_.isFunction(fun)) {
                    if (fun(element)) counts[key] += 1;
                }
            }
        }
    }
    return counts;
}
//-----------------------------------------------------------------------------------
export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}
export function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
export function generateRandomColorRgb() {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    return "rgb(" + red + ", " + green + ", " + blue + ")";
}

// Usage
// function App() {
//     const [hoverRef, isHovered] = useHover();
//     return <div ref={hoverRef}>{isHovered ? "😁" : "☹️"}</div>;
// }
// Hook
export function useHover() {
    const [value, setValue] = useState(false);

    // Wrap in useCallback so we can use in dependencies below
    const handleMouseOver = useCallback(() => setValue(true), []);
    const handleMouseOut = useCallback(() => setValue(false), []);

    // Keep track of the last node passed to callbackRef
    // so we can remove its event listeners.
    const ref = useRef();

    // Use a callback ref instead of useEffect so that event listeners
    // get changed in the case that the returned ref gets added to
    // a different element later. With useEffect, changes to ref.current
    // wouldn't cause a rerender and thus the effect would run again.
    const callbackRef = useCallback(
        node => {
            if (ref.current) {
                ref.current.removeEventListener("mouseover", handleMouseOver);
                ref.current.removeEventListener("mouseout", handleMouseOut);
            }

            ref.current = node;

            if (ref.current) {
                ref.current.addEventListener("mouseover", handleMouseOver);
                ref.current.addEventListener("mouseout", handleMouseOut);
            }
        },
        [handleMouseOver, handleMouseOut]
    );

    return [callbackRef, value];
}
export function useFocus() {
    const [value, setValue] = useState(false);

    // Wrap in useCallback so we can use in dependencies below
    const handleFocus = useCallback(() => setValue(true), []);
    const handleBlur = useCallback(() => setValue(false), []);

    // Keep track of the last node passed to callbackRef
    // so we can remove its event listeners.
    const ref = useRef();

    // Use a callback ref instead of useEffect so that event listeners
    // get changed in the case that the returned ref gets added to
    // a different element later. With useEffect, changes to ref.current
    // wouldn't cause a rerender and thus the effect would run again.
    const callbackRef = useCallback(
        node => {
            console.log(ref, ref.current);
            if (ref.current) {
                ref.current.removeEventListener("focus", handleFocus);
                ref.current.removeEventListener("blur", handleBlur);
            }

            ref.current = node;

            if (ref.current) {
                ref.current.addEventListener("focus", handleFocus);
                ref.current.addEventListener("blur", handleBlur);
            }
        },
        [handleFocus, handleBlur]
    );

    return [callbackRef, value];
}
//-------------------------------------------------------------------------------------------

export function MaxIcon({color, width, height}) {
    return <svg  style={{marginBottom: "2px"}} xmlns="http://www.w3.org/2000/svg" width={`${width||24}px`} height={`${height||24}px`} viewBox="0 0 720 720"><path fill={color||"#0a0b0b"} d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"/></svg>
}